<template>
	<div>
		<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<div class="btn-toolbar pull-right" role="toolbar">
							<div class="btn-group" role="group" aria-label="...">
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<h4 class="modal-title">Tipo de documento</h4>
					</div>
					<div class="modal-body">
						<p>Añade una solicitud o presupuesto, también podrás añadir el presupuesto desde la solicitud si lo deseas.</p>
					</div>
					<div class="list-group m-b-0">
						<button @click="addBudget()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-clipboard fa-fw"></i>
							Presupuesto
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addRequest()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-info-circle fa-fw"></i>
							Solicitud
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<request-create
			@reload="reload()"
			@openEditRequest="openEditRequest"
			fast="true"
			ref="requestCreate"
			:user="user"
			:isAuth="isAuth">
		</request-create>
		<request-edit
			@reload="reload()"
			ref="requestEdit"
			:user="user"
			:isAuth="isAuth">
		</request-edit>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	import RequestCreate from '@/components/requests/views/Create.vue'
	import RequestEdit from '@/components/requests/views/Edit.vue'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'request-create': RequestCreate,
			'request-edit': RequestEdit,
		},
		data () {
			return {
				modal: {
					selector: 'modal-add-budget-or-request'
				},
			}
		},
		mounted() {
			var that = this
			$('#'+this.modal.selector).on('hidden.bs.modal', function () {
				that.$router.replace({'query': null})
			})
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.$emit('reload')
			},
			addRequest() {
				this.close()
				var that = this
				this.$refs.requestCreate.open(this.data, 'customer')
			},
			addBudget() {
				this.close()
				var that = this
				var data = {
					customer_id: this.data.id
				}
				swal.queue([{
					title: this.$t("messages.attention"),
					text: this.$t("messages.budget_will_be_created"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/budgets', data)
							.then(response => {
								that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
								swal({ 
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			openEditRequest(request) {
				this.$refs.requestEdit.open(request)
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/customers/views/BudgetOrRequest.vue